import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { Deserialize } from "cerialize";
import { Adresse } from "../models/adresse";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BanAdresse } from "../models/banAdresse";

@Injectable({
  providedIn: 'root'
})
export class BanService {

  constructor(private http: HttpClient) {
  }

  public search(terms: string): Promise<Adresse[]> {
    let headers = new HttpHeaders();
    headers = headers.set('No-Loader', '');
    return this.http.get(`${environment.api.adresseUrl}?q=${terms}`, {headers: headers}).toPromise().then(
      (data: any) => {
        const adresses = [];
        data.features.forEach(item => {
          const adresse = Deserialize({
            label: item.properties.label,
            numero: item.properties.housenumber,
            nom_voie: item.properties.street,
            code_postal: item.properties.postcode,
            nom_commune: item.properties.city,
            longitude: item.geometry.coordinates[0],
            latitude: item.geometry.coordinates[1],
            code_insee: item.properties.citycode
          }, BanAdresse) as BanAdresse;

          if (!adresse.nomVoie && !adresse.numero) {
            adresse.nomComplementaire = item.properties.name;
          }
          adresse.apiAdresse = this.computeApiAdresse(adresse);
          adresses.push(adresse)
        });
        return adresses;
      },
      (data) => {
        throw new Error('An unexpected error occurred while data loading : ' + JSON.stringify(data));
      });
  }

  private computeApiAdresse(adresse: BanAdresse) {
    return [
      adresse.numero,
      adresse.nomVoie,
      adresse.nomComplementaire,
      adresse.codePostal,
      adresse.nomCommune,
      adresse.longitude,
      adresse.latitude,
      adresse.codeInsee
    ].filter(Boolean).join(" ");
  }
}
